export const isVepormasHost = (): boolean => {
    const allowedHosts = ['firma.vepormas.com'];
    return allowedHosts.some((host) => window.location.hostname === host);
};
